import { createSelector } from 'reselect';

const experianStateSelector = state => state.experian;

export const subscribersSelector = createSelector(
  experianStateSelector,
  ({ subscribers }) => subscribers,
);

export const hasSubscribersSelector = createSelector(
  experianStateSelector,
  ({ subscribers }) => subscribers.length > 0,
);

export const isFetchingReportSelector = createSelector(
  experianStateSelector,
  ({ isFetchingReport }) => isFetchingReport,
);

export const isFetchingSubscribersSelector = createSelector(
  experianStateSelector,
  ({ isFetchingSubscribers }) => isFetchingSubscribers,
);

export const isFetchingDarkWebDataSelector = createSelector(
  experianStateSelector,
  ({ isFetchingDarkWebData }) => isFetchingDarkWebData,
);

export const subscriberEnrollingSelector = createSelector(
  experianStateSelector,
  ({ subscriberEnrolling }) => subscriberEnrolling,
);

export const isEnrollModalOpenSelector = createSelector(
  experianStateSelector,
  ({ isEnrollModalOpen }) => isEnrollModalOpen,
);

export const enrollErrorSelector = createSelector(
  experianStateSelector,
  ({ enrollError }) => enrollError,
);

export const verificationQuestionsSelector = createSelector(
  experianStateSelector,
  ({ verificationQuestions }) => verificationQuestions,
);

export const questionsSelector = createSelector(
  verificationQuestionsSelector,
  ({ Questions }) => Questions,
);

export const isFetchingQuestionsSelector = createSelector(
  experianStateSelector,
  ({ isFetchingQuestions }) => isFetchingQuestions,
);

export const isCancellingSubscriptionSelector = createSelector(
  experianStateSelector,
  ({ isCancellingSubscription }) => isCancellingSubscription,
);

export const isAcceptingTermsSelector = createSelector(
  experianStateSelector,
  ({ isAcceptingTerms }) => isAcceptingTerms,
);

export const isSubmittingQuestionsSelector = createSelector(
  experianStateSelector,
  ({ isSubmittingQuestions }) => isSubmittingQuestions,
);

export const questionsLoadErrorsSelector = createSelector(
  experianStateSelector,
  ({ questionsLoadErrors }) => questionsLoadErrors,
);

export const questionsErrorsSelector = createSelector(
  experianStateSelector,
  ({ questionsErrors }) => questionsErrors,
);

export const acceptingTermsErrorsSelector = createSelector(
  experianStateSelector,
  ({ acceptingTermsErrors }) => acceptingTermsErrors,
);

export const darkWebModalErrorsSelector = createSelector(
  experianStateSelector,
  ({ darkWebModalErrors }) => darkWebModalErrors,
);

export const isArchivingAlertSelector = createSelector(
  experianStateSelector,
  ({ isArchivingAlert }) => isArchivingAlert,
);

export const isUnarchivingAlertSelector = createSelector(
  experianStateSelector,
  ({ isUnarchivingAlert }) => isUnarchivingAlert,
);

export const isFetchingActiveAlertsSelector = createSelector(
  experianStateSelector,
  ({ isFetchingActiveAlerts }) => isFetchingActiveAlerts,
);

export const isFetchingMoreActiveAlertsSelector = createSelector(
  experianStateSelector,
  ({ isFetchingMoreActiveAlerts }) => isFetchingMoreActiveAlerts,
);

export const isFetchingArchivedAlertsSelector = createSelector(
  experianStateSelector,
  ({ isFetchingArchivedAlerts }) => isFetchingArchivedAlerts,
);

export const isFetchingMoreArchivedAlertsSelector = createSelector(
  experianStateSelector,
  ({ isFetchingMoreArchivedAlerts }) => isFetchingMoreArchivedAlerts,
);

export const subscribersErrorsSelector = createSelector(
  experianStateSelector,
  ({ subscribersErrors }) => subscribersErrors,
);
